import { isNil } from 'lodash-es';

import { PRIVILEGE_SHOW_CONSTRAINT, PRIVILEGE_SHOW_INDEX } from '../../constants';

const UpdatedDatabaseActions = [PRIVILEGE_SHOW_INDEX, PRIVILEGE_SHOW_CONSTRAINT];
export const getNoProcedurePermissionMessage = (
  missingProcedure?: string,
  user?: string | null,
  roles?: string | string[] | null,
) => {
  if (isNil(missingProcedure)) {
    return;
  }
  const explanation = UpdatedDatabaseActions.includes(missingProcedure)
    ? 'Bloom requires visibility of database indexes and constraints to function. '
    : '';

  let command: string;
  switch (missingProcedure) {
    case PRIVILEGE_SHOW_INDEX:
      command = 'SHOW INDEX';
      break;
    case PRIVILEGE_SHOW_CONSTRAINT:
      command = 'SHOW CONSTRAINT';
      break;
    default:
      command = missingProcedure;
  }

  const userString = !isNil(user) && user.length > 0 ? `User "${user}"` : 'The current user';
  const roleString =
    !isNil(roles) && roles?.length > 0 ? ` with role(s) ${typeof roles === 'string' ? roles : roles.join(', ')}` : '';
  return `${explanation}${userString}${roleString} needs to have permission granted to execute "${command}". Please contact your database administrator.`;
};
